import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import {
  useGetConfigurationQuery,
  useGetMLStoresQuery,
} from 'api/ml-service/ml-service';
import { mlConfigurationSchema } from './ml-configuration-form.schema';
import { useQueryWithForm, useSuspendQueries } from 'hooks/rtkq.hooks';

export const useMlConfigurationsForm = () => {
  const queryResult = useSuspendQueries(
    useGetConfigurationQuery(null),
    useGetMLStoresQuery(null),
  );
  const form = useForm({
    resolver: yupResolver(mlConfigurationSchema),
    defaultValues: mlConfigurationSchema.cast({}),
  });

  const { reset } = form;

  const modifiedQueryResult = {
    ...queryResult,
    data: {
      ...queryResult.data[0],
      locationIds: queryResult.data[1]?.locations
        .filter(location => location.locationEnabled)
        .map(location => ({
          id: location.locationId,
          label: location.locationName,
        })),
    },
  };

  useQueryWithForm(form, modifiedQueryResult, mlConfigurationSchema);

  const handleReset = () => {
    reset(mlConfigurationSchema.cast(modifiedQueryResult.data));
  };

  return { form, queryResult, handleReset };
};
